export default "__VITE_ASSET__f4b49d17__"